module.exports = __webpack_public_path__ + "img/doge.08394e1c.svg";